import React from 'react'
import { NewSiteTabItem, NewSiteTabWrapper } from './style'
import { FormattedMessage } from 'react-intl'

const SiteProposalHeaderTabs = ({ changeTab, active }) => {
  return (
    <NewSiteTabWrapper onClick={changeTab} data-test="tabs">
      <NewSiteTabItem isActive={active === 'details'} id="details">
        <FormattedMessage id="siteDetails" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'map'} id="map">
        <FormattedMessage id="map" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'about'} id="about">
        <FormattedMessage id="about" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'assessment'} id="assessment">
        <FormattedMessage id="assessment" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'monitoring'} id="monitoring">
        <FormattedMessage id="threatsAndAction" />
      </NewSiteTabItem>
      <NewSiteTabItem isActive={active === 'kba-criterias'} id="kba-criterias">
        <FormattedMessage id="criteriaKba" />
      </NewSiteTabItem>
    </NewSiteTabWrapper>
  )
}

export default SiteProposalHeaderTabs
